/**
 * AboutSLAboutPageView
 *
 * Page component for AboutSLAboutPageView
 * Path: /sl/about
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AboutSLAboutPageView as __AboutSLAboutPageView } from '@/components/traits/AboutSLAboutPageView';
import { AboutSLAboutAnalyticsView as __AboutSLAboutAnalyticsView } from '@/components/traits/AboutSLAboutAnalyticsView';
import { AboutSLDemoChecksFetcherView as __AboutSLDemoChecksFetcherView } from '@/components/traits/AboutSLDemoChecksFetcherView';
import { AboutSLDemoChecksDeskView as __AboutSLDemoChecksDeskView } from '@/components/traits/AboutSLDemoChecksDeskView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ToastSlot } from '@almadar/ui/components';

interface AboutSLAboutPageViewProps {
  // Add any page-level props here
}

export function AboutSLAboutPageView(_props: AboutSLAboutPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-about:meta.title"],"description":["i18n/t","std-almadar-about:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/about"},{"locale":"ar","path":"/ar/about"},{"locale":"sl","path":"/sl/about"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AboutSLAboutPageView config={{ initPayload: __navState }} />
          <__AboutSLAboutAnalyticsView config={{ initPayload: __navState }} />
          <__AboutSLDemoChecksFetcherView config={{ initPayload: __navState }} />
          <__AboutSLDemoChecksDeskView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default AboutSLAboutPageView;
